import * as Yup from 'yup';
import * as companyEmailValidator from 'company-email-validator';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

function equalTo(ref, msg) {
    return Yup.mixed().test({
        name: 'equalTo',
        exclusive: false,
        message: msg || 'Path must be the same as Reference',
        params: {
            reference: ref.path,
        },
        test: function (value) {
            return value === this.resolve(ref);
        },
    });
}

Yup.addMethod(Yup.string, 'equalTo', equalTo);

export default Yup.object().shape({
    countryCode: Yup.string().required('Country code is required.'),
    firstName: Yup.string().required('Required'),
    middleName: Yup.string().when('noMiddleName', {
        is: false,
        then: Yup.string().required('Required'),
    }),
    lastName: Yup.string().required('Required'),
    email: Yup.string()
        .email('Please enter a valid company email')
        .required('Company email is required')
        .test(
            'is-company-email',
            'Please enter a valid company email',
            (email) => email && companyEmailValidator.isCompanyEmail(email)
        ),
    dob: Yup.string().nullable().required('Required'),
    accept: Yup.boolean().oneOf([true], 'Checkbox is required'),
    phoneNumber: Yup.string()
        .required('Phone number is required')
        .test('is-valid-phone-number', 'Please enter a valid phone number', function (value) {
            const { countryCode } = this.parent;
            if (!value || !countryCode) return false;

            const formattedContact = `+${value}`;
            const parsedContact = parsePhoneNumberFromString(formattedContact);
            const isValid = parsedContact?.isValid() || false;

            return isValid;
        }),
    captcha: Yup.string().required('Required'),
    passcode: Yup.boolean().oneOf([true], 'Checkbox is required'),
});
